import styled from "styled-components";

export const EditStructureWrapper = styled.div`
  width: 100%;
  margin-top: 40px;
  margin-bottom: 10px;
  height: 500px;
`;

export const EditStructureHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 13.48px;

  > .title {
    color: #1a191a;
    font-family: Pretendard;
    font-size: 20.22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const EditStructureHeaderButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  > .button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 158px;
    height: 40px;
    cursor: pointer;
    color: white;
    background-color: #969696;
    border-radius: 15px;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .button.purple {
    background: #7f25fb;
  }
`;

export const EditStructureTableWrapper = styled.div`
  padding: 0 20px;
  box-sizing: border-box;
  flex: 1;
  background-color: #f0f0f0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

export const EditStructureTableHeader = styled.div`
  width: 946px;
  padding: 20px 0px 14px;
  display: flex;
  flex-direction: row;
  border-bottom: 2px solid #d9d9d9;
  position: relative;
  background-color: #f0f0f0;

  > .box {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #121212;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .box.z {
    width: 6%;
  }

  > .box.a {
    width: 50px;
  }

  > .box.c {
    width: 11%;
  }

  > .box.d {
    width: 14%;
  }
`;

export const EditStructureTableHeaderButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  position: absolute;
  right: 0;
  top: 18px;

  > .move {
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;

export const EditStructureTableBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  overflow-y: auto;
  scrollbar-width: none;
  max-height: 375px;
  padding: 15px 0;
  box-sizing: border-box;
`;

export const EditStructureTableItemWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 40px;
  align-items: center;
  gap: 7px;
`;

export const EditStructureTableItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 40px;
  border-radius: 15.04px;
  background: #fff;
  padding: 0 17px;

  > .box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  > .box.a {
    width: 50px;
    font-weight: 500;
  }
`;

export const EditStructureItemCheckBox = styled.div<{ checked: boolean }>`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  background: ${(p) => (p.checked ? "#7f25fb" : "#fff")};
`;

export const EditStructureItemBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--kakao-logo, #000);
  text-align: center;
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const EditStructureTimeItem = styled(EditStructureItemBox)`
  width: 13%;
  > .data {
    width: 50px;
    height: 24px;
    border-radius: 10px;
    background: #f0f0f0;
    text-align: center;
    border: none;
    outline: none;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const EditStructureBreakItem = styled(EditStructureItemBox)`
  width: 45%;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    width: calc(100% - 32px);
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 10px;
    background: #f0f0f0;
  }
`;

export const EditStructureItem = styled(EditStructureItemBox)`
  width: 15%;
  > .data {
    width: 90px;
    height: 24px;
    border-radius: 10px;
    background: #f0f0f0;
    text-align: center;
    border: none;
    outline: none;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const EditStructureButton = styled(EditStructureItemBox)`
  width: 20%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 25px;
  justify-content: flex-end;

  > .button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 32px;
    cursor: pointer;
    border-radius: 10px;
    background: #f0f0f0;
    font-size: 14px;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  > .button.purple {
    border-radius: 10px;
    background: #7f25fb;
    color: white;
  }

  > img {
    cursor: pointer;
    width: 14.996px;
    height: 14.996px;
  }
`;
